import isSSR from './../config/isSSR';

export default (userAgentParam, regExp, optionalConstrain = true) => {
  const userAgent = userAgentParam || (!isSSR() && window.navigator.userAgent);

  return typeof userAgent === 'string' && regExp.test(userAgent) && optionalConstrain;
};
